import { PlayerAhoyEvent } from "../player_ahoy_event";
import { PlayerEnvironment } from "../player_environment";
import DrmDetector from '../utils/drm_detector';

export default class VideoPlenty {
  constructor(options = {}){
    this._tech = options.tech;
    this._data = options.data;
    this._drmDetector = new DrmDetector();
  }

  data(){
    return this._data;
  }

  tech(){
    return this._tech;
  }

  drmDetector() {
    return this._drmDetector;
  }

  bindEvents(){
    this.setAhoyEventGlobalProperties();
    this.bindPause();
    this.bindResume();
    this.bindSeek();
    this.bindMeta();
    this.bindError();
    this.bindStart();
    this.bindPlay();

    this.bindAdWatch();

    this.bindUnmuteButtonLoad();
    this.bindUnmuteButtonClick();
  }

  bindPause(){
    this.tech().on("vp-video-pause", function(e){
      PlayerAhoyEvent.sendPause(e.id, e.play_uuid, e.genreIds, e.userTriggered);
    });
  }

  bindResume(){
    this.tech().on("vp-video-resume", function(e){
      PlayerAhoyEvent.sendResume(e.id, e.play_uuid);
    });
  }

  bindSeek(){
    this.tech().on("vp-video-seek", function(e){
      PlayerAhoyEvent.sendSeek(e.id, e.position, e.offset, e.play_uuid, e.action);
    });
  }

  bindMeta(){
    this.tech().on("vp-video-meta", function(e){
      PlayerAhoyEvent.sendMeta(
        e.id,
        e.level,
        e.levels,
        e.targetBitrate,
        e.play_uuid,
        e.genreIds
      );
    });
  }

  bindError(){
    this.tech().on("vp-video-error", function(e){
      PlayerAhoyEvent.sendError(e.id,
        e.errorCode,
        e.errorMessage,
        e.videoDuration,
        e.currentTime,
        e.play_uuid,
        e.readyState,
        e.networkState,
        e.bufferedVideoFrames,
        e.tokenRefreshCount
      );
    });
  }

  bindStart(){
    this.tech().on("vp-video-start", (e) => {
      this.drmDetector().widevineHdcpCheck().then(hdcp_support => {
        PlayerAhoyEvent.sendStart(
          e.id,
          e.videoDuration,
          e.hasAd,
          e.autoplay,
          e.play_uuid,
          e.genreIds,
          e.currentTime,
          e.readyState,
          e.networkState,
          e.bufferedVideoFrames,
          e.tokenRefreshCount,
          e.bandwidth,
          e.quality,
          e.codec,
          e.is_drm,
          hdcp_support,
          e.videoSourceBitrate,
          e.videoSourceHeight,
          e.videoSourceWidth,
          e.playerHeight,
          e.playerWidth,
        );
      }).catch(() => {
        PlayerAhoyEvent.sendStart(
          e.id,
          e.videoDuration,
          e.hasAd,
          e.autoplay,
          e.play_uuid,
          e.genreIds,
          e.currentTime,
          e.readyState,
          e.networkState,
          e.bufferedVideoFrames,
          e.tokenRefreshCount,
          e.bandwidth,
          e.quality,
          e.codec,
          e.is_drm,
          'unknown',
          e.videoSourceBitrate,
          e.videoSourceHeight,
          e.videoSourceWidth,
          e.playerHeight,
          e.playerWidth,
        );
      })
    });
  }

  bindPlay() {
    this.tech().on('vp-video-play', (e) => {
      PlayerAhoyEvent.sendPlay(
        e.video_id,
        e.position,
        e.duration,
        e.play_uuid,
        e.bandwidth,
        e.quality,
        e.networkState,
        e.has_ad,
        e.video_duration,
        e.autoplay,
        e.videoSourceBitrate,
        e.videoSourceHeight,
        e.videoSourceWidth,
        e.playerHeight,
        e.playerWidth,
      );
    });
  }

  bindAdWatch(){
    this.tech().on("vp-video-adwatch", function(e){
      PlayerAhoyEvent.sendAdWatch(
        e.id,
        e.duration,
        e.currentTime,
        e.play_uuid,
        e.adUUID,
        e.ad_type
      );
    });
  }

  bindUnmuteButtonLoad(){
    this.tech().on("vp-unmute-button-load", function(e){
      PlayerAhoyEvent.sendUnmuteButtonLoad(
        e.play_uuid,
        e.id,
        e.videoDuration,
        e.hasAd,
        e.autoplay
      );
    });
  }

  bindUnmuteButtonClick(){
    this.tech().on("vp-unmute-button-click", function(e){
      PlayerAhoyEvent.sendUnmuteButtonClick(
        e.play_uuid,
        e.id,
        e.videoDuration,
        e.hasAd,
        e.autoplay
      );
    });
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
